// Admin Authentication Helper
const adminAuthEndpoints = {
    login: ['/api/mochi/login', '/mochi/login'],
    logout: ['/api/mochi/logout', '/mochi/logout']
};

async function tryParseJson(response) {
    try {
        return await response.json();
    } catch {
        return null;
    }
}

async function postWithFallback(urls, body) {
    let lastError = null;

    for (const url of urls) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
                credentials: 'include'
            });

            return { response, url };
        } catch (error) {
            lastError = error;
            console.warn(`Admin auth request failed for ${url}.`, error);
        }
    }

    throw lastError ?? new Error('Admin auth request failed.');
}

async function loginAdmin(email, password, rememberMe, recaptchaToken) {
    try {
        const payload = {
            email,
            password,
            rememberMe,
            recaptcha: recaptchaToken
        };

        const { response } = await postWithFallback(adminAuthEndpoints.login, payload);
        const data = await tryParseJson(response);

        if (response.ok) {
            return {
                success: true,
                message: data?.message,
                name: data?.name
            };
        }

        return {
            success: false,
            message: data?.message || `Login failed (${response.status})`
        };
    } catch (error) {
        console.error('Admin login error:', error);
        return {
            success: false,
            message: 'Unable to reach admin login endpoint. Please refresh and try again.'
        };
    }
}

// Logout an admin user
async function logoutAdmin() {
    try {
        const { response } = await postWithFallback(adminAuthEndpoints.logout, {});
        const data = await tryParseJson(response);

        if (response.ok) {
            return {
                success: true,
                message: data?.message || 'Logged out successfully'
            };
        }

        return {
            success: false,
            message: data?.message || 'Logout failed'
        };
    } catch (error) {
        console.error('Admin logout error:', error);
        return {
            success: false,
            message: 'An error occurred during logout'
        };
    }
}



// Export admin auth functions to global window object
window.adminAuthHelpers = {
    loginAdmin,
    logoutAdmin
}; 